// get the url based on the plotform

import { Platform } from "react-native";

/**
* Dynamically gets the BFF Web URL based on the current browser location
* For web: extracts domain from browser address bar and appends /BFF_Web
* For mobile: uses environment variables or defaults
*/
const getBffWebUrl = (): string => {
  // For web platform, dynamically get URL from browser
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try {
      // Get the current URL from the browser's address bar
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);

      // For localhost, return the original localhost URL
      if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
        return 'http://localhost:8080';
      }

      if (url.hostname === '10.0.2.2') {
        return 'http://10.0.2.2:8080';
      }

      const protocol = url.protocol;
      const hostnameParts = url.hostname.split('.');

      // Handle edge case where hostname has no dots (single part)
      if (hostnameParts.length < 2) {
        return `https://${url.hostname}/quickstage-bff-web`;
      }

      const subdomain = hostnameParts[0];
      const domain = hostnameParts.slice(1).join('.');

      // Map moneygram.com domains to AWS domains
      if (domain === 'moneygram.com') {
        return `${protocol}//${subdomain}.moneygram.com/quickstage-bff-web`;
      }
      // // For external domains, extract domain and append /BFF_Web
      // const domain = url.hostname;
      // const protocol = url.protocol;
      // // const port = url.port ? `:${url.port}` : '';
      // console.log('domain', protocol, domain);

      return `https://${url.hostname}/quickstage-bff-web`;
    } catch (error) {
      console.warn('Failed to parse browser URL, falling back to default:', error);
      return 'http://localhost:8080';
    }
  }

  // For React Native (iOS/Android), use environment variables or defaults
  if (Platform.OS === 'ios' || Platform.OS === 'android') {
    // In development, try to connect to the development server
    if (__DEV__) {
      // For iOS simulator, localhost works
      if (Platform.OS === 'ios') {
        return process.env.REACT_APP_BFF_WEB_URL || 'http://localhost:8080';
      }
      // For Android, we need to use the machine's IP address
      return process.env.REACT_APP_BFF_WEB_URL || 'http://10.0.2.2:8080';
    }

    // In production, use the production API URL
    return process.env.REACT_APP_BFF_WEB_URL || 'https://d2agentworks.aws.moneygram.com/quickstage-bff-web';
  }

  // Fallback
  return 'http://localhost:8080';
};

export const API_ENDPOINTS = {
  // API endpoints
  //LOAD_COUNTRIES: '/api/country',
  LOAD_COUNTRIES: '/api/common/country',
  GET_LOCATION_BY_KID: '/api/common/location',
  FEE_LOOKUP_INIT: '/api/send/FeeLookup',
  CONSUMER_LOOKUP: '/api/common/ConsumerLookup',
  AUTH_CONSUMER: '/api/send/AuthConsumer',
  GET_FIELDS_FOR_PRODUCT: '/api/send/getFieldsForProductRequest',
  UPDATE_CONSUMER_PROFILE: '/api/send/updateConsumerProfile',
  VALIDATE_CONSUMER: '/api/send/validateConsumer',
  POST_TRANSACTION_TO_KIOSK: '/api/common/postTransactionToKiosk',
  REFERENCE_NUMBER_SEARCH: '/api/receive/ReferenceNumberSearch',
  GET_FIELDS_FOR_PRODUCT_FOR_RECEIVE: '/api/receive/getFieldsForProductRequest',
  VALIDATE_CONSUMER_FOR_RECEIVE: '/api/receive/validateConsumer',
}

/**
* Gets the API URL for the current platform and environment
*/
export const getApiUrl = (endpoint: string): string => {
  return `${getBffWebUrl()}${endpoint}`;
 // return getBffWebUrl();
};

export const version = '1.0.0';

//export const getApiUrl = (endpoint: string) => {
 //   return `${getBffApiUrl()}${endpoint}`;
 // }; 
 